import React from 'react';
import { Modal, ListGroup, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

function VisitorDetailsModal({ visitor, onClose, eventID }) {
    const { t } = useTranslation();
    const getTime = (seconds) => moment().startOf('day').seconds(seconds).format('HH:mm:ss');
    const {
        firstName,
        lastName,
        company,
        jobTitle,
        email,
        phone,
        timeCreated,
        timeLatestActivity,
        activityTime
    } = visitor;

    return (
		<Modal
            show
            onHide={onClose}
			size="lg"
			aria-labelledby="contained-modal-title-vcenter"
			centered
		>
			<Modal.Header closeButton>
				<Modal.Title id="contained-modal-title-vcenter">
                    {(firstName.length || lastName.length)
                        ? <strong>{firstName} {lastName}</strong>
                        : <strong>{t('analytics.anonymous_visitor')}</strong>
                    }
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<ListGroup variant="flush">
                    {company ?
                        <ListGroup.Item>
                            <div className="row">
                                <div className="col-sm-4">
                                    <strong>{t('general.company')}</strong>
                                </div>
                                <div className="col-sm-8">
                                    {company}
                                </div>
                            </div>
                        </ListGroup.Item> 
                    : null}
                    {jobTitle ?
                        <ListGroup.Item>
                            <div className="row">
                                <div className="col-sm-4">
                                    <strong>{t('general.job_title')}</strong>
                                </div>
                                <div className="col-sm-8">
                                    {jobTitle}
                                </div>
                            </div>
                        </ListGroup.Item>
                    : null}
                    {eventID !== '0c01107f-e93d-11ea-a21a-ee6a04371b85' ?
                        <>
                            {email ?
                                <ListGroup.Item>
                                    <div className="row">
                                        <div className="col-sm-4">
                                            <strong>{t('general.email')}</strong>
                                        </div>
                                        <div className="col-sm-8">
                                            {email}
                                        </div>
                                    </div>
                                </ListGroup.Item>
                            : null}
                            {phone ?
                                <ListGroup.Item>
                                    <div className="row">
                                        <div className="col-sm-4">
                                            <strong>{t('general.phone_number')}</strong>
                                        </div>
                                        <div className="col-sm-8">
                                            {phone}
                                        </div>
                                    </div>
                                </ListGroup.Item>
                            : null}
                        </>
                    : null}
                    {timeCreated ?
                        <ListGroup.Item>
                            <div className="row">
                                <div className="col-sm-4">
                                    <strong>{t('analytics.first_seen')}</strong>
                                </div>
                                <div className="col-sm-8">
                                    {moment(timeCreated).format('DD.MM.YYYY HH:mm') + ' UTC'}
                                </div>
                            </div>
                        </ListGroup.Item>
                    : null}
                   {timeLatestActivity ?
                    <ListGroup.Item>
                            <div className="row">
                                <div className="col-sm-4">
                                    <strong>{t('analytics.latest_activity')}</strong>
                                </div>
                                <div className="col-sm-8">
                                    {moment(timeLatestActivity).format('DD.MM.YYYY HH:mm') + ' UTC'}
                                </div>
                            </div>
                        </ListGroup.Item>
                    : null}
                    {activityTime ?
                        <ListGroup.Item>
                            <div className="row">
                                <div className="col-sm-4">
                                    <strong>{t('analytics.activity_time')}</strong>
                                </div>
                                <div className="col-sm-8">
                                    {getTime(activityTime)}
                                </div>
                            </div>
                        </ListGroup.Item>
                    : null}
                </ListGroup>
			</Modal.Body>
			<Modal.Footer>
				<Button
					type="button"
					variant="default"
					onClick={onClose}
				>
					{t('general.close')}
				</Button>
			</Modal.Footer>
		</Modal>
	);
}

export default VisitorDetailsModal;